import { dashboardSelectBusiness } from '@/modules/dashboard/dashboardActions';
import type { Business } from '@/modules/dashboard/dashboardTypes';
import type { RootState } from '@/rootReducer';
import { sendAnalytics } from '@/services/analyticsService';
import { useDispatch, useSelector } from 'react-redux';

export const useSelectBusinessMutation = () => {
	const dispatch = useDispatch();
	const user = useSelector((state: RootState) =>
		state.user.getIn(['authorize', 'user']).toJS()
	);

	const isUserOnboarding = user?.onboarding?.status === 'pending';

	const mutate = (business: Business | null) => {
		dispatch(dashboardSelectBusiness(business));

		if (!business && !isUserOnboarding) return;

		sendAnalytics({
			type: 'track',
			userId: user.email,
			eventName: isUserOnboarding
				? 'Onboarding Flow - Clicked to View business'
				: 'User opened business side panel in sequences',
			properties: {
				businessId: business?.id
			}
		});
	};

	return { mutate };
};
